import { Context } from '@nuxt/types'
import { addModules, getStoreModules } from '@ustra/nuxt/src/vue/store/index'
import { InterceptorScope } from '@ustra/core/src/utils/axios-utils'
import { axiosUtils, logger } from '@ustra/core'
import { HttpNetworkError } from '@ustra/core/src/error/'
import { LogLevel } from '@ustra/core/src/config/config-properties'
import { isMatchPatterns } from '@ustra/core/src/utils/string-utils'
import * as nuxtUtils from '@ustra/nuxt/src/utils/nuxt-utils'
import { MenuDataModule } from '../store/modules/menu-data-module'
import { CommonDataModule } from '../store/modules/cm-data-module'
import { HsAuthModule } from '../store/modules/hs-auth-module'
import hdhsMiddleware from '../middlewares/hdhs-middleware'
import { Auth } from './desc/auth'

/**
 * 공통 모듈
 */
export class HdhsPlugin {
  private context: Context = null

  constructor(context: Context) {
    this.context = context
    this.init()
  }

  private init() {
    // register store module
    addModules(this.context, { hsAuth: HsAuthModule, cmData: CommonDataModule, menuData: MenuDataModule })

    // 공통 인터셉터
    this.context.$ustra.api.addRequestInterceptor({
      key: 'common-req-interceptor',
      scope: InterceptorScope.BOTH,
      onFulfilled: (req) => {
        const _context = nuxtUtils.contextHolder.get()

        if (!req.headers['device-id']) req.headers['device-id'] = this.store.cmData.deviceId
        if (_context.$ustra.store.auth().refreshToken) this.store.cmData.setRefreshToken(_context.$ustra.store.auth().refreshToken)
      },
    })

    // 응답 에러 처리 인터셉터
    this.context.$ustra.api.addResponseInterceptor({
      key: 'hdhs-api-res-error-process-interceptor',
      scope: InterceptorScope.BOTH,
      processAllError: true,
      index: 0,
      onFulfilled: (res) => {
        // logger().debug({
        //   message: 'hdhs-api-res-error-process-interceptor',
        //   args: [],
        // })

        const appProp = this.context.$ustra.env.appProp
        const addDetailErrorLog = appProp.logger.level >= LogLevel.Debug

        // 검증을 수행하지 않을 URL 처리
        if (appProp.api?.ignoreErrorUrlPatterns) {
          if (isMatchPatterns(res.config.url, ...appProp.api.ignoreErrorUrlPatterns)) {
            return res
          }
        }

        // @ts-ignore
        if (res && res.data && res.data.resultCode && !res.config.passOnResponseError) {
          if (res.data.resultCode !== '0000') {
            let message = res.data.resultMessage

            if (addDetailErrorLog && res.data.errors) {
              for (const error of res.data.errors) {
                message += '/' + error
              }
            }
            throw new HttpNetworkError(new Error(message), res.data.resultCode)
          }
        }
        return res
      },
      onRejected: (error) => {
        error.message = axiosUtils.getAxiosErrorMessage(error)
        // TODO  body 추출할 것
        throw new HttpNetworkError(error, null)
      },
    })

    this.auth = new Auth(this.context)
  }

  /**
   * Store
   */
  public store = {
    get auth() {
      return getStoreModules().hsAuth() as HsAuthModule
    },

    get cmData() {
      return getStoreModules().cmData() as CommonDataModule
    },

    get menuData() {
      return getStoreModules().menuData() as MenuDataModule
    },
  }

  /**
   * 인증 권한 기능 지원 유틸리티
   */
  public auth: Auth = null
}

export default (context: Context) => {
  // 미들웨어 등록
  context.$ustra.middleware.hdhs = hdhsMiddleware

  context.$ustra.hs = new HdhsPlugin(context)
}
